import { useDispatch } from 'react-redux'
import { createWorkorder, getWorkorders } from 'app/workorder/state/workorder/actions'
import { IWorkorderResponse } from '@cbgms/api'
import { query } from '@cbgms/components/list'

/**
 * useGetOrCreateOrderUUIDForEmployee always returns an workorder-uuid for the account.
 * If none exists yet, it'll create employee-order.
 */
export const useGetOrCreateOrderUUIDForAccount = () => {
  const dispatch = useDispatch()

  return async (accountUUID: string, vehicleUUID?: string) => {
    let search = query<IWorkorderResponse>().equals(o => o.Account.UUID, accountUUID)
    if (vehicleUUID) {
      search = search.and().equals(o => o.Vehicle.UUID, vehicleUUID)
    } else {
      search = search.and().isNull(o => o.Vehicle.UUID)
    }
    // check for open orders.
    const orders = await dispatch(getWorkorders({ search: search.toString(), orderBy: 'Workorder.CreatedAt|DESC' }))
    if (orders.Data.length) {
      const firstOrder = orders.Data[0]
      return firstOrder.Workorder.UUID
    }

    const response = await dispatch(createWorkorder({ AccountUUID: accountUUID || undefined, VehicleUUID: vehicleUUID || undefined }))
    return response.Data.UUID
  }
}
